import { useState } from 'react';
import { useEffect } from 'react';
import { AllocationService } from '@utility/services';

import { z } from 'zod';

const suggestionSchema = z.object({
  locationId: z.string(),
  code: z.string(),
  available: z.number(),
});

const allocationSuggestionSchema = z.object({
  suggestions: z.array(suggestionSchema).default([]),
});

export type AllocationSuggestion = z.infer<typeof suggestionSchema>;

export function useAllocationsLocation(warehouseId?: string, allocationIds?: string[]) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<AllocationSuggestion[]>([]);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await AllocationService.getAllocationsLocation({
        warehouseId,
        allocationIds,
      });
      const parsedData = allocationSuggestionSchema.parse(res);
      setData(parsedData.suggestions);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (warehouseId && allocationIds) {
      fetchData();
    } else {
      setData([]);
    }
  }, [warehouseId, allocationIds]);

  return { data, loading, error, fetchData };
}
